// This is included with pageContributions and created as a chunk from webpack config.
const buttons = document.querySelectorAll('.list-person__expand');
for (let i = 0; i < buttons.length; i++) {
	buttons[i].addEventListener('click', (e) => {
		e.target.nextElementSibling.classList.toggle('list-person__more--open');
		e.stopPropagation();
	});
}
